// Mẫu câu trả lời nhanh — lưu trong localStorage để admin tự thêm/bớt
const STORAGE_KEY = "admin_canned_replies";

const DEFAULTS = [
    "Cảm ơn bạn đã góp ý, bên mình đã ghi nhận ạ.",
    "Bạn vui lòng nhắn mã đơn hàng để bên mình kiểm tra giúp nhé.",
    "Hoàn tiền sẽ về sau khi sàn xác nhận đơn hợp lệ, bạn yên tâm nhé.",
    "Bạn vui lòng kiểm tra lại trong mục Ví của bạn giúp mình ạ.",
    "Dạ vâng, bên mình hỗ trợ bạn ngay đây ạ.",
];

export function getCannedReplies() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch {
        /* ignore parse error */
    }
    return DEFAULTS;
}

export function saveCannedReplies(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}
